var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgFavourite15X = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "32px",
  height: "28px",
  viewBox: "0 0 32 28",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  ref: ref,
  "aria-labelledby": titleId
}, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, "6C0CCF28-A3C7-44E1-9EBA-8B84D3BBA3FC@1.5x") : title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Prototyping",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Desktop-1440-/-Home-Page-/-Default-/-Featured",
  transform: "translate(-536.000000, -175.000000)",
  fill: "#8d6dea"
}, /*#__PURE__*/React.createElement("g", {
  id: "Hero-Section-/-Featured",
  transform: "translate(208.000000, 120.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Heading-/-Favourites",
  transform: "translate(328.000000, 50.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Icon-/-Favourite",
  transform: "translate(0.000000, 5.055556)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M29.7075749,13.4947821 L27.8285379,15.3901166 L21.5525543,21.8342541 L16.0281856,27.4444444 L10.5038168,21.8342541 L10.4286553,21.7584408 L8.21139166,19.521946 L2.3112155,13.5705955 C-0.770405167,10.4622468 -0.770405167,5.42065684 2.3112155,2.31230816 C3.77686436,0.833947207 5.73106283,0.0379066912 7.873165,0.0379066912 C9.90252496,0.0379066912 11.9318849,0.871853898 13.4351145,2.31230816 L16.0281856,4.92786986 L18.6212566,2.31230816 C20.0869055,0.833947207 22.0786847,0 24.1832061,0 C26.2877275,0 28.2795068,0.833947207 29.7451556,2.31230816 C31.2108045,3.79066912 32,5.76181707 32,7.92249847 C32,10.0452732 31.1732237,12.0164211 29.7075749,13.4947821 Z",
  id: "Heart"
}))))))));

const ForwardRef = /*#__PURE__*/forwardRef(SvgFavourite15X);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Favourite@1_5x.3eec246bd375d2ff2bbebaafd4cf56fe.svg";